const FormatTimeStr = (dato: string, onlyDate: boolean = false) => {
  let year = dato.substring(0, 4);
  let month = dato.substring(5, 7);
  let day = dato.substring(8, 10);
  let hour = dato.substring(11, 13);
  let minutes = dato.substring(14, 16);
    
  return `${day}.${month}.${year}${onlyDate ? "" : ` kl. ${hour}:${minutes}`}`
}

export default FormatTimeStr;